<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="subtitle">
        {{ name }}
      </div>
      <div class="is-flex">
        <figure class="image">
          <img :src="image" :alt="name">
        </figure>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String
    },
    image: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped>
  .is-flex {
    justify-content: center;
  }
  .image {
    max-width: 150px;
    max-height: 200px;
  }
  .gob .image {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RequiredEquipment.vue